class MachineService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getMachines(params) {
    return this.apiService.get('/api/v1/one/machine', params);
  }

  createMachine(params) {
    return this.apiService.post('/api/v1/one/machine', params);
  }

  updateMachine(params) {
    return this.apiService.put(`/api/v1/one/machine/${params.id}`, params);
  }

  deleteMachine(params) {
    return this.apiService.delete('/api/v1/one/machine', params);
  }
}

export default MachineService;
